import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserLicense } from '../models/user-licence.model';
import { ApiEndpoint } from './rest/rest.model';
import { RestService } from './rest/rest.service';

@Injectable()
export class UserLicenceService {
  constructor(private rest: RestService) {}
  public deleteUser(userId: number): Observable<UserLicense> {
    return this.rest.deleteCall(ApiEndpoint.USER_LICENSE_DELETE, {userId});
  }
}
